module.exports = __webpack_public_path__ + "static/media/choon.9fb20809.gif";